var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"my-4 text-center text-h6",attrs:{"name":("process[" + (_vm.field.nombre) + "]")},domProps:{"innerHTML":_vm._s(_vm.field.etiqueta)}})}
var staticRenderFns = []

export { render, staticRenderFns }